import { useMutation } from '@tanstack/react-query';
import { addAffectedHoneyField } from '../services';

export const useAddAffectedHoneyField = () =>
  useMutation(['add-affected-honey-field'], addAffectedHoneyField);
